import React, { useRef } from "react";
import PointIcon from "../../Assets/imgNewUI/point-coin-2.png";
import getTranslation from "../../TranslationUtility/TranslationUtility";

import { useEffect, useState } from "react";
import API from "../../Common/Endpoint/serviceConstrants";
import axiosIntegration from "../../Common/Axios/axiosIntegration";
import { trackEvent, ApiConfigData, UtilityReducer, formatIndianNumber, encodeBase64, decodeBase64, ClientPlatformCode, UserIdAndStatusData, DefaultCardName, DefaultCard } from "../../Utility/Utility";
import { useDispatch, useSelector } from "react-redux";
import { onSaveIamge, onSetApiError, onUpdatePointBalance } from "../../Store/Slices/utilityReducer";
import { useNavigate } from "react-router-dom";
import CardLoader from "../CardLoader";



const PointBalance = ({ id, showTour, isMyAccount }) => {

    const dispatch = useDispatch();
    const translation = getTranslation();
    const [cardLoader, setCardLoader] = useState(false);
    const [accountData, setAccountData] = useState([]);
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [apiCallDone, setApiCallDone] = useState(false);
    const reduxTotalPointBalance = useSelector((state) => state.utilityReducer.totalPointBalance);
    const clientMasterData = useSelector((state) => state.clientMasterReducer);
    const pointIcon = clientMasterData?.clientMasterData?.[0]?.pointIcon || '';
    const [totalPointBalance, setTotalPointBalance] = useState(reduxTotalPointBalance);
    const generateToken = useSelector((state) => state.generateTokenSliceReducer);
    const card = UtilityReducer();
    const apiconfig = ApiConfigData();
    const partnerCode = apiconfig?.find(
        (data) => data?.paramsKey === "partnerCode"
    )?.paramsValue;
    const clientCode = apiconfig?.find(
        (data) => data?.paramsKey === "clientCode"
    )?.paramsValue;

    const myAccountString = apiconfig?.find(
        (data) => data?.paramsKey === "myaccount"
    )?.paramsValue;

    let myAccountData = {};

    try {
        if (typeof myAccountString === "string") {
            myAccountData = JSON.parse(myAccountString);
        } else if (typeof myAccountString === "object" && myAccountString !== null) {
            myAccountData = myAccountString;
        }
    } catch (err) {
        console.error("❌ JSON parse error:", err, myAccountString);
        myAccountData = {};
    }

    const selectcardData = JSON.parse(sessionStorage.getItem("selectedCard"))?.card;

    const creditCards = card?.creditCards;
    const { clientCode: clientPlatformCode, platformCode } = ClientPlatformCode();
    const { userId, userStatus } = UserIdAndStatusData();
    const defaultCardName = DefaultCardName();
    const defaultCardData = DefaultCard();

    // const currenDebitRewardPoints = Math.floor(card?.totalPointBalance);
    const currentImage = card?.currentBg;
    const loginToken = useSelector(
        (state) => state.validateLoginTokenSliceReducer
    );
    const defaultCard = loginToken?.data?.subIdentifier;
    const [selectedCard, setSelectedCard] = useState(() => {
        const savedCard = sessionStorage.getItem("selectedCard");
        return savedCard ? JSON.parse(savedCard) : null;
    });
    const dispatchedRef = useRef(false);
    // Format number with Indian commas (e.g., 2,40,00,000)

    const callSwitchAccountApi2 = async (payload) => {
        // Prevent API call if on /my-account and data already exists
        if (window.location.pathname === "/my-account") {
            return;
        }
        try {
            setLoading(true);
            const { data = [] } = await axiosIntegration.post(
                API.switchAccountApi,
                payload,
                {
                    headers: {
                        clientCode: clientCode,
                        partnerCode: partnerCode,
                    },
                }
            );

            setAccountData((prevData) =>
                Array.isArray(prevData) ? [...prevData, data] : [data]
            );
            dispatch(onSetApiError(false));
        } catch (error) {
            // On error, update accountData with the specified error object, using the payload for response fields
            // console.error("Error switching account:", payload);
            const data = {
                contentToLog: null,
                response: {
                    memberBalance: null,
                    identifier: payload.identifier,
                    subIdentifier: payload.subIdentifier,
                    identifierType: payload.identifierType,
                    userSessionToken: payload.userSessionToken,
                    isAccountSwitch: payload.isAccountSwitch
                },
                responseCode: "400",
                responseMessage: "fail",
                responseAttributes: null
            }
            setAccountData((prevData) =>
                Array.isArray(prevData) ? [...prevData, data] : [data]
            );

            dispatch(onSetApiError(true));
        } finally {
            setLoading(false);
            sessionStorage.setItem("autoSelect", true);
        }
    };

    // Remove apiCallDone from sessionStorage on page reload or navigation back
    useEffect(() => {
        setCardLoader(true);
        sessionStorage.removeItem("apiCallDone");
    }, []);

    useEffect(() => {
        if (!apiCallDone) {
            const apiCallFlag = sessionStorage.getItem("apiCallDone");
            if (!apiCallFlag) {
                const cardPromises = creditCards?.filter(card => card?.status === "1")?.map((cardData) =>
                    callSwitchAccountApi2({
                        identifier: loginToken?.data?.memberIdentifier,
                        subIdentifier: cardData?.identifier,
                        identifierType: parseInt(cardData?.identifiertype),
                        userSessionToken: sessionStorage.getItem("temporaryToken"),
                        isAccountSwitch: false,
                    })
                );
                Promise.all(cardPromises).then(() => {
                    setApiCallDone(true);
                    sessionStorage.setItem("apiCallDone", "true");
                });
            }
        }
    }, [apiCallDone, creditCards, loginToken?.data?.memberIdentifier]);

    useEffect(() => {
        if (apiCallDone) {
            let updatedCards;
            if (!accountData?.length) {
                const hasUndefined = creditCards?.filter(card => card?.status === "1")?.some(card => typeof card.pointBalance !== "number");
                let total = translation.myAccount;
                if (!hasUndefined) {
                    total = Math.floor(creditCards?.filter(card => card?.status === "1")?.reduce((acc, card) => {
                        if (typeof card.pointBalance === "number" && card.pointBalance > 0) {
                            return acc + card.pointBalance;
                        }
                        return acc;
                    }, 0));
                } else {
                    total = translation.myAccount;
                }
                setTotalPointBalance(total);
                setCardLoader(false);
                return;
            } else {
                updatedCards = creditCards?.map((card) => {
                    const matchingAccount = accountData?.find(
                        (account) => account?.response?.subIdentifier === card.identifier
                    );
                    return matchingAccount
                        ? {
                            ...card,
                            pointBalance: matchingAccount?.response?.memberBalance?.pointBalance,
                            showTryAgain: false,
                            showViewPoint: false,
                            totalPointBalance: matchingAccount?.response?.memberBalance?.totalPointBalance,
                        }
                        : card;
                });
                setCardLoader(false);
            }

            let total = translation.myAccount;
            // Only dispatch if updatedCards is different from creditCards
            const isDifferent = updatedCards && creditCards && updatedCards.some((card, idx) => {
                const orig = creditCards[idx];
                total = Math.floor(updatedCards?.filter(card => card?.status === "1")?.reduce((acc, card) => {
                    if (typeof card.pointBalance === "number" && card.pointBalance > 0) {
                        return acc + card.pointBalance;
                    }
                    return acc;
                }, 0));
                return card.pointBalance !== orig.pointBalance || card.totalPointBalance !== orig.totalPointBalance;
            });
            // Use a ref to ensure dispatch only once per update
            if (isDifferent && !dispatchedRef.current) {
                // Sum all pointBalance values and remove decimal
                const hasUndefined = updatedCards?.filter(card => card?.status === "1")?.some(card => typeof card.pointBalance !== "number");

                if (!hasUndefined) {
                    total = Math.floor(updatedCards?.filter(card => card?.status === "1")?.reduce((acc, card) => {
                        if (typeof card.pointBalance === "number" && card.pointBalance > 0) {
                            return acc + card.pointBalance;
                        }
                        return acc;
                    }, 0));
                }
                setTotalPointBalance(total);
                setCardLoader(false)
                dispatch(onUpdatePointBalance({ updatedCreditCards: updatedCards, totalPointBalance: total }));
                dispatchedRef.current = true;
            }
            if (!isDifferent) {
                setTotalPointBalance(total);
                setCardLoader(false)
                dispatchedRef.current = false;
                // Always update total in store even if cards did not change
                dispatch(onUpdatePointBalance({ updatedCreditCards: updatedCards, totalPointBalance: total }));
            }
        }
    }, [apiCallDone, accountData.length]);



    const callSwitchAccountApi = async (
        payload,
        cardData,
        isApiCall,
        defaultCard,
        homePage
    ) => {
        if (!generateToken?.data?.accessToken) {
            console.error("Access token is missing");
            return;
        }

        axiosIntegration.defaults.headers["access-token"] =
            generateToken.data.accessToken;

        const updateCardData = (card, balanceData, error = false) => ({
            ...card,
            pointBalance: error ? undefined : balanceData?.pointBalance,
            totalPointBalance: error
                ? card.totalPointBalance
                : balanceData?.totalPointBalance,
            showTryAgain: error,
            showViewPoint: false,
        });

        const saveImageData = (balanceData, error = false) => ({
            currentPoints: error ? undefined : balanceData?.pointBalance,
            totalPointBalance: error
                ? cardData?.totalPointBalance
                : balanceData?.totalPointBalance,
            currentBg: cardData?.backgroundcolor,
            cardName: cardData?.CardTypeName,
            showTryAgain: error,
            showViewPoint: false,
        });

        try {
            setLoading(true);

            const { data = {} } = await axiosIntegration.post(
                API.switchAccountApi,
                payload,
                {
                    headers: { clientCode, partnerCode },
                }
            );

            const balanceData = data?.response?.memberBalance;

            const updatedCards = creditCards?.map((card) =>
                card.identifier === data?.response?.subIdentifier
                    ? updateCardData(card, balanceData)
                    : card
            );

            dispatch(onUpdatePointBalance({ updatedCreditCards: updatedCards }));

            if (!isApiCall || defaultCard || homePage) {
                dispatch(onSaveIamge(saveImageData(balanceData)));
                if (defaultCard || homePage) setIsOpen(false);
            }

            dispatch(onSetApiError(false));
        } catch (error) {
            console.error("Error switching account:", error);

            const updatedCards = creditCards?.map((card) =>
                card.identifier === payload?.subIdentifier
                    ? updateCardData(card, null, true)
                    : card
            );
            dispatch(onSetApiError(true));
            dispatch(onUpdatePointBalance({ updatedCreditCards: updatedCards }));

            if (!isApiCall) {
                dispatch(onSaveIamge(saveImageData(null, true)));
            }
        } finally {
            setLoading(false);
            if (!isApiCall) setIsOpen(false);
        }
    };


    const autoSelect = sessionStorage.getItem("autoSelect");
    const [error, setError] = useState(false);
    const selectCard = async (
        index,
        type,
        card,
        isApiCall,
        defaultCard,
        homePage
    ) => {
        const cardInfo = { index, type, card };
        !isApiCall && setSelectedCard(cardInfo);
        !isApiCall &&
            sessionStorage.setItem("selectedCard", JSON.stringify(cardInfo));
        const payload = {
            identifier: loginToken?.data?.memberIdentifier,
            subIdentifier: card?.identifier,
            identifierType: parseInt(card?.identifiertype),
            userSessionToken: sessionStorage.getItem("loginSessionToken"),
            isAccountSwitch: isApiCall ? false : true,
        };
        setCardLoader(true);
        setTimeout(() => {
            setCardLoader(false);
        }, 2000);
        if (autoSelect || isApiCall) {
            try {
                await callSwitchAccountApi(
                    payload,
                    card,
                    isApiCall,
                    defaultCard,
                    homePage
                );
            } catch (error) { }
        }
    };


    useEffect(() => {
        if (creditCards?.length && !selectedCard) {

            const finalCredicards = creditCards?.filter(
                (card) => card?.identifiertype === "1002"
            );
            const finalDebitcards = creditCards?.filter(
                (card) => card?.identifiertype === "1001"
            );

            const allCards = [...finalCredicards, ...finalDebitcards];

            const getCardData = () => {
                const defaultCardData = allCards?.find(
                    (card) => card?.identifier === defaultCard
                );
                if (defaultCardData) return defaultCardData;

                return finalCredicards.length ? finalCredicards[0] : finalDebitcards[0];
            };

            const cardData = getCardData();

            selectCard(
                defaultCard !== null && defaultCard !== ""
                    ? cardData?.identifier
                    : cardData?.identifier,
                cardData?.identifierType,
                cardData
            );
        }
    }, [creditCards, selectedCard, defaultCard]);



    useEffect(() => {
        if (currentImage) {

            const img = new Image();
            img.src = currentImage;

            img.onload = () => setError(false);
            img.onerror = () => setError(true);
        } else {
            setError(true);
        }
    }, [currentImage]);

    const handleNavigate = () => {
        const totalPointBalanceData = creditCards.reduce(
            (sum, card) => sum + (card.pointBalance || 0),
            0
        );
        trackEvent("my_profile_click", {
            page_url: window.location.href,
            points: totalPointBalanceData,
            cta_text: Number(totalPointBalanceData) ? "Balance Points" : "My account",
            page_type: window.location.pathname === "/my-account" ? "my_account_page" : "home_page",
            client_code: clientPlatformCode,
            platform_code: platformCode,
            user_id: userId,
            user_status: userStatus,
            card_name: defaultCardName
        });
        navigate("/my-account");
    };

    const isMyAccountPage = window.location.pathname === "/my-account";
    let displayBalance = translation.myAccount;
    if (isMyAccountPage) {
        // Show balance if available, even if creditCards is empty
        if (typeof (totalPointBalance ?? reduxTotalPointBalance) === "number" && !isNaN(totalPointBalance ?? reduxTotalPointBalance)) {
            displayBalance = formatIndianNumber(totalPointBalance ?? reduxTotalPointBalance);
        }
    } else {
        if (myAccountData?.IsDefaultCardPointBalance) {
            displayBalance = formatIndianNumber(Math.floor(selectcardData?.pointBalance || defaultCardData?.pointBalance));
        } else {
            displayBalance = creditCards?.length > 0
                ? formatIndianNumber(totalPointBalance ?? reduxTotalPointBalance)
                : translation.myAccount;
        }

        if (displayBalance === "0") {
            displayBalance = translation.myAccount;
        }
    }

    return (
        <>
            <div id={id} className={`${isMyAccount ? "pointBalance-myaccount" : "pointBalance"}`} onClick={cardLoader ? null : () => handleNavigate()}>
                {((!displayBalance && isMyAccount) || (displayBalance)) && <>
                    <>
                        {pointIcon && <div className="card-point-icon"><img
                            src={`${process.env.REACT_APP_CLIENT_IMAGE_URL}${pointIcon}`}
                            alt="Card not found" />
                        </div>}
                        <div className={`card-points text-gradient ${!pointIcon ? "pl-2" : ""}`}>
                            {cardLoader ? <CardLoader /> : displayBalance}
                        </div>
                    </>
                </>}
            </div>
            {isMyAccount && translation?.totalRewardsPoints && <span className="total-rewards-points">{translation?.totalRewardsPoints}</span>}
        </>
    );
};

export default PointBalance;